<template>


<div>
    <b-modal  
    :no-close-on-esc="true"
     :no-close-on-backdrop="true"
      @shown="onShown()"
      :hide-header="true"
      :hide-footer="true"
      content-class="modal-blue"
      id="change-eng-level-modal"
      size="md"
      scrollable
      centered>
        <!-- Modal content-->
        <div class="row ">
          <div class="col mb-5 ">
            <h4 class="mb-4">დონის გადარჩევა</h4>
            
                
               <p v-for="(subject,i)  of canChangeOnSubjects[0].canChangeOnSubjects" style="cursor:pointer" @click="handleclick(canChangeOnSubjects[0].students_ret_tempID,subject.subjectID)"> {{subject.subject_code}} | {{  subject.subject}} </p>
 

          </div>
        </div>
        <div class="row">
          <div class="col mt-0 pt-3 mt-sm-5 pt-sm-0 mb-3">
            <button type="button" class="btn btn-light-bold" @click="hideModal()">{{ $t('registration.close') }}</button>
          </div>
        </div>
    </b-modal>
     
  </div>





    </template>

    <script>

    import ScheduleResource from '../../api/scheduleResource'
    const scheduleResource=new ScheduleResource()

    export default{

        data(){

            return{

                 

            }

        },
        props:['canChangeOnSubjects'],
        
        methods:{

            hideModal() {
        this.$bvModal.hide('change-eng-level-modal');
        this.$emit('closed'); 
        location.reload()
         
        
      },
      onShown(){

    



      },
     
      handleclick(students_ret_tempID,newSubjectID){

            if(confirm("ნამდვილად გსურთ დონის შეცვლა?")){


                scheduleResource.changeEngLevel(students_ret_tempID,newSubjectID).then(()=>{
                    this.hideModal()
                })



            }


      }


        }



    }



</script>